/**
 * Blog Posts Index
 * This file imports all blog posts and their metadata
 */

// Import all blog metadata
import multiTenantMetadata from './multi-tenant-architecture/metadata.json';
import gdprMetadata from './gdpr-compliance-guide/metadata.json';
import techstoreMetadata from './techstore-success-story/metadata.json';
import aiTrendsMetadata from './ai-trends-2024/metadata.json';
import chatbotRoiMetadata from './chatbot-roi-measurement/metadata.json';
import conversationalUIMetadata from './conversational-ui-best-practices/metadata.json';

// Import all blog content by language
import multiTenantEn from './multi-tenant-architecture/en.json';
import multiTenantDe from './multi-tenant-architecture/de.json';
import gdprEn from './gdpr-compliance-guide/en.json';
import gdprDe from './gdpr-compliance-guide/de.json';
import techstoreEn from './techstore-success-story/en.json';
import techstoreDe from './techstore-success-story/de.json';
import aiTrendsEn from './ai-trends-2024/en.json';
import aiTrendsDe from './ai-trends-2024/de.json';
import chatbotRoiEn from './chatbot-roi-measurement/en.json';
import chatbotRoiDe from './chatbot-roi-measurement/de.json';
import conversationalUIEn from './conversational-ui-best-practices/en.json';
import conversationalUIDe from './conversational-ui-best-practices/de.json';

// Map blog slugs to their content
const blogContent = {
  'multi-tenant-architecture': {
    en: multiTenantEn,
    de: multiTenantDe
  },
  'gdpr-compliance-guide': {
    en: gdprEn,
    de: gdprDe
  },
  'techstore-success-story': {
    en: techstoreEn,
    de: techstoreDe
  },
  'ai-trends-2024': {
    en: aiTrendsEn,
    de: aiTrendsDe
  },
  'chatbot-roi-measurement': {
    en: chatbotRoiEn,
    de: chatbotRoiDe
  },
  'conversational-ui-best-practices': {
    en: conversationalUIEn,
    de: conversationalUIDe
  }
};

// All blog metadata
export const blogMetadata = [
  multiTenantMetadata,
  gdprMetadata,
  techstoreMetadata,
  aiTrendsMetadata,
  chatbotRoiMetadata,
  conversationalUIMetadata
];

/**
 * Get all blog posts with metadata, sorted by date (newest first)
 */
export function getAllBlogs() {
  return blogMetadata
    .map(metadata => ({
      ...metadata,
      date: new Date(metadata.date)
    }))
    .sort((a, b) => b.date - a.date);
}

/**
 * Get a specific blog post by slug
 * @param {string} slug - Blog post slug
 * @param {string} language - Language code (en, de, etc.)
 * @returns {object|null} Blog post with metadata and content, or null if not found
 */
export function getBlogBySlug(slug, language = 'en') {
  const metadata = blogMetadata.find(blog => blog.slug === slug);
  if (!metadata) {
    return null;
  }

  const content = blogContent[slug]?.[language] || blogContent[slug]?.['en'] || null;
  if (!content) {
    return null;
  }

  return {
    ...metadata,
    ...content,
    date: new Date(metadata.date)
  };
}

/**
 * Get blog content for a specific slug and language
 * @param {string} slug - Blog post slug
 * @param {string} language - Language code
 * @returns {object|null} Blog content or null
 */
export function getBlogContent(slug, language = 'en') {
  return blogContent[slug]?.[language] || blogContent[slug]?.['en'] || null;
}

const blogExports = {
  getAllBlogs,
  getBlogBySlug,
  getBlogContent,
  blogMetadata
};
export default blogExports;







